import ChatWindow from "../ChatWindow/ChatWindow";
import { useEffect, useMemo } from "react";
import { useStores } from "../../../index";
import { observer } from "mobx-react-lite";
import { checkIsBotTyping, groupMessages } from "../utils";
import { isEmpty } from "lodash";
import { useCookies } from "react-cookie";
import { useModal } from "../../../context/ModalContext"; // ✅ Импортируем модальное окно


const BoostChat = observer(({ onBack, toggleChat }) => {
    const { user, aiChat } = useStores();
    const { showModal } = useModal(); // ✅ Подключаем глобальное модальное окно

    const hasAccess = user?.user?.purchased_courses?.length > 0;
    const isPending = aiChat?.courseAiChat?.state === 'pending' ||
        (aiChat?.pending && isEmpty(aiChat?.messages));
    const chatId = aiChat?.courseAiChat?.value?.chat?.id;


    const [tokenCached, setToken, removeToken] = useCookies('access_token');
    const token = tokenCached.access_token

    const handleMessage = (message, base64image) => {
        if (message && !base64image) {
            aiChat.sendMessage({ message, type: "text" });
        } else if (!message && base64image) {
            aiChat.sendMessage({ photo: base64image, type: "img" });
        } else if (message && base64image) {
            aiChat.sendMessage({ photo: base64image, message, type: "img+text" });
        }
    }

    const getNext = () => {
        aiChat.loadMore()
    };

    const groupedMessages = useMemo(
        () => groupMessages(aiChat.messages ?? []),
        [aiChat.messages]
    );

    const isBotTyping = checkIsBotTyping(groupedMessages);

    useEffect(() => {
        if (!token || !chatId || !hasAccess) return;

        aiChat.connect({
            chatId,
            accessToken: token,
            userId: user?.user?.id
        });
    }, [user?.user?.id, chatId, hasAccess]);

    // Если нет доступа, показываем модалку
    useEffect(() => {
        if (!hasAccess) {
            showModal(
                <div>
                    <h2>У вас нет доступа к чату</h2>
                    <p>Этот чат доступен только для пользователей с купленными курсами.</p>
                </div>
            );
            toggleChat(); // Закрываем чат
        }
    }, [hasAccess, showModal, toggleChat]);

    return (
        <ChatWindow
            isTyping={isBotTyping}
            groupedMessages={groupedMessages}
            isPending={isPending}
            title="Boost"
            onBack={onBack}
            toggleChat={toggleChat}
            onMessage={handleMessage}
            getNext={getNext}
            canAttachFile={true}
        />
    );
}
)
export default BoostChat;